import axios from 'axios';
import {
  BookingConfig,
  BookingConfigEnum,
} from '../../components/BookingWidget/bookingSteps.interface';
import { RequestHeaders } from '../interfaces/requestHeaders.interface';
import ErrorLoggingService from './errorlogging.service';
import { SessionParams } from '../../context/sessionContext/sessionContext.interface';
import authHelper from '../helpers/auth.helper';

const useApi = (
  bookingConfigData: BookingConfig,
  sessionParams: SessionParams | null,
): any => {
  const errorService: ErrorLoggingService = ErrorLoggingService.getInstance();
  const { getRawToken } = authHelper();
  const apiCM360Url: string =
    bookingConfigData[BookingConfigEnum.DataCenter]?.cm360Endpoint;
  const apiCM360Key: string =
    bookingConfigData[BookingConfigEnum.DataCenter]?.cm360Key;
  const api = axios.create({
    baseURL: apiCM360Url,
  });

  api.interceptors.request.use(
    async (config) => {
      const modifiedConfig = { ...config };
      const token = getRawToken();
      if (!modifiedConfig.headers[RequestHeaders.X_API_KEY]) {
        modifiedConfig.headers[RequestHeaders.X_API_KEY] = apiCM360Key;
      }
      if (
        !modifiedConfig.headers[RequestHeaders.X_CURRENT_SESSION_CONTEXT] &&
        sessionParams?.sessionToken
      ) {
        modifiedConfig.headers[RequestHeaders.X_CURRENT_SESSION_CONTEXT] =
          sessionParams.sessionToken;
      }
      modifiedConfig.headers[RequestHeaders.CONTENT_TYPE] = 'application/json';

      if (!modifiedConfig.headers.Authorization && token) {
        modifiedConfig.headers.Authorization = `Bearer ${token}`;
      }

      return modifiedConfig;
    },
    (error) => Promise.reject(error),
  );

  api.interceptors.response.use(
    async (response) => response,
    (error) => {
      errorService.log(error.message, error);
      return Promise.reject(error);
    },
  );

  return api;
};

export default useApi;
